/**
 * The dropped `File` objects, outside the store (which only takes serialisable state). They live as long
 * as the page: a reload loses them, which is why the draft records file identities to match re-drops.
 */
const handles = new Map<string, Map<string, File>>()

export const attachFileHandles = (draftId: string, files: { key: string; file: File }[]) => {
  const forDraft = handles.get(draftId) ?? new Map<string, File>()
  files.forEach(({ key, file }) => forDraft.set(key, file))
  handles.set(draftId, forDraft)
}

export const fileHandle = (draftId: string, key: string): File | undefined => handles.get(draftId)?.get(key)

/** Whether a sample's reads can be read: its file, and its R2 when it has one. */
export const readsAtHand = (draftId: string, group: { forward: string; reverse?: string }): boolean =>
  !!fileHandle(draftId, group.forward) && (!group.reverse || !!fileHandle(draftId, group.reverse))

export const releaseFileHandles = (draftId: string) => {
  handles.delete(draftId)
}

export const retainFileHandles = (draftId: string, keys: ReadonlySet<string>) => {
  const forDraft = handles.get(draftId)
  for (const key of [...(forDraft?.keys() ?? [])]) {
    if (!keys.has(key)) {
      forDraft?.delete(key)
    }
  }
}

/** Every draft's handles; for tests, which share the module across cases. */
export const releaseAllFileHandles = () => {
  handles.clear()
}
